export interface RowItem {
  width: number;
  rightGutter: number;
}

export interface PositionedItem {
  x: number;
  width: number;
}

class GroupRowHelper {
  static chunk<T>(items: ReadonlyArray<T>, size: number): T[][] {
    return Array.from(
      { length: Math.ceil(items.length / size) },
      (_unused, i) => items.slice(i * size, (i + 1) * size)
    );
  }

  // A gutter widens the gap to the item's right.
  static place(items: ReadonlyArray<RowItem>, gap: number): number[] {
    const xs: number[] = [];
    let cursor = 0;
    items.forEach((item) => {
      xs.push(cursor);
      cursor += item.width + item.rightGutter + gap;
    });
    return xs;
  }

  static nearestGapX(
    items: ReadonlyArray<PositionedItem>,
    targetX: number
  ): number | null {
    const gaps = items
      .slice(1)
      .map((item, i) => Math.round((items[i].x + items[i].width + item.x) / 2));
    if (gaps.length === 0) return null;
    return gaps.reduce((best, x) =>
      Math.abs(x - targetX) < Math.abs(best - targetX) ? x : best
    );
  }
}

export { GroupRowHelper };
